<!-- eslint-disable no-irregular-whitespace -->
<template>
  <div class="activity-mine">
    <page-header title="我的活动" style="margin-bottom: 20px" />

    <ul v-loading="loading" class="activity-list">
      <li v-for="item in pageData" :key="item.id" class="list-item" :class="{ disabled: item.expired }">
        <div v-if="splitDate(item.startTime)" class="date">
          <span class="day">{{ splitDate(item.startTime).day }}</span>
          <span class="year-date">{{ splitDate(item.startTime).year }}-{{ splitDate(item.startTime).month }}</span>
        </div>
        <div class="item-main" @click="routerActivityItem(item.id)">
          <h3>
            {{ item.title }} 　 <el-tag v-if="item.userApply == 1" type="success" size="medium"> 报名成功 </el-tag>
            <el-tag v-if="item.userApply == -2" type="warning" size="medium"> 报名失败 </el-tag>　<el-tag
              v-if="item.signState == 0 && item.userApply === 1"
              type="info"
              effect="plain"
              size="medium"
            >
              未签到
            </el-tag>
            <el-tag v-if="item.signState == 1" type="success" effect="plain" size="medium"> 已签到 </el-tag>
          </h3>

          <div class="item-main-info">
            <!-- 活动时间 -->
            <span class="el-icon-time"></span> 活动时间：{{ item.startTime }} ~ {{ item.endTime }}
            <!-- 地址 -->
            <el-divider direction="vertical"></el-divider> <span class="el-icon-location-outline"></span>
            <span v-if="+item.isOnline === 0" class="ellipsis" :title="item.address">{{ item.address }}</span>
            <span v-else class="">线上</span>
            <!-- 是否过期 -->
            <template v-if="item.expired">
              <el-divider direction="vertical"></el-divider> <span class="el-icon-warning-outline"></span>
              <span>活动已结束</span>
            </template>
          </div>
        </div>
        <!-- 活动报名截止 1成功 -2失败  -1 未报名  0参与了报名-->
        <!-- item.isApply  是否需要报名 -->
        <div v-if="item.isApply == 1" style="width: 200px; display: flex; justify-content: flex-end; flex-wrap: wrap">
          <template v-if="item.expired">
            <div v-if="item.userApply == 1 || item.userApply == -2" class="link-btn disabled">取消参与</div>
            <div v-else class="link-btn disabled">参与报名</div>
          </template>
          <template v-else>
            <div v-if="item.userApply == 1 || item.userApply == -2" class="link-btn disabled">取消参与</div>
            <div v-if="item.userApply === 0" class="link-btn" @click="cancleApply(item.id)">取消参与</div>
          </template>
          <!--  {{ item.isHpAssessment ? '有' : '无' }} -->
          <template v-if="item.userApply === 1">
            <div v-if="item.signUrl && item.signState == 0" class="link-btn" @click="sign(item.signUrl)">前往签到</div>
            <div v-if="+item.isAssessment === 1 && item.userApply == 1" class="link-btn" @click="RouterToActivityAssetssment(item.id, 'activity')">
              {{ item.assessmentState ? '查看评估' : '活动评估' }}
            </div>
            <div v-if="item.isHpAssessment > 0" class="link-btn" @click="RouterToActivityAssetssment(item.id, 'acthp')">
              {{ item.hpAssessmentState ? '查看互评' : '活动互评' }}
            </div>
          </template>
        </div>
        <div v-else class="link-btn disabled">无需报名</div>
      </li>
      <li>
        <empty-component v-if="!pageData?.length" text="暂无相关信息"></empty-component>
      </li>
    </ul>
    <div class="pageDiv">
      <el-pagination
        background
        layout="prev, pager, next"
        :hide-on-single-page="true"
        :page-size="pageSize"
        :total="total"
        :current-page.sync="curPage"
        @current-change="pageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { MessageBox, Message } from 'element-ui'
import PageHeader from '@/components/PageHeader'
import { PaginationHook } from '@/hooks/paginationHook'
import API from '@/api'
import Router from '@/router'
import EmptyComponent from '@/components/EmptyComponent.vue'
const { loading, total, curPage, getData, pageData, pageChange, pageSize } = PaginationHook('myActivityList')

function splitDate(date) {
  const regex = /^((19|20)[0-9]{2})-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/
  const newDate = date.split(' ')[0]
  if (regex.test(newDate)) {
    const [year, month, day] = newDate.replace(regex, '$1,$2,$3').split(',')

    return { year, month, day }
  }

  return false
}
function sign(url) {
  window.open(url)
}
function cancleApply(id) {
  MessageBox.confirm(`您确定要取消参与该活动吗？`, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  })
    .then(() => {
      API.cancelActSignUp({ id }).then(res => {
        if (+res.code === 200) {
          Message.success(res.msg)
          getData({ page: curPage.value, pageSize: pageSize.value })
        }
      })
    })
    .catch(() => {
      console.log('取消')
    })
}

// 跳转至详情页
function routerActivityItem(id) {
  Router.push({
    name: 'ActivityDetail',
    params: { id }
  })
}

// 跳转到活动评估
function RouterToActivityAssetssment(id, type) {
  if (!id) return
  Router.push({
    name: 'ActivityAssessment',
    params: { id },
    query: { type }
  })
}

onMounted(() => {
  getData({ page: 1, pageSize: pageSize.value })
})
</script>

<style lang="scss" scoped>
.activity-list {
  width: 100%;
  min-height: 100px;
  list-style: none;
  padding: 0;
  margin: 0;
  margin-bottom: 20px;

  .list-item {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 20px;
    box-sizing: border-box;

    &:not(:last-child) {
      border-bottom: 1px solid #eeeeee;
      margin-bottom: 20px;
    }

    &.disabled {
      color: #666;

      .date {
        .day {
          background-color: #f0f0f0;
          color: #bbbbbb;
        }

        .year-date {
          background-color: #bbbbbb;
        }
      }

      .is-disabled {
        border-color: #bbbbbb;
      }
    }

    .date {
      flex-basis: 66px;
      margin-right: 20px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      border-radius: 4px;
      overflow: hidden;

      .day {
        display: block;
        width: 100%;
        height: 43px;
        background-color: #f0f0f0;
        line-height: 43px;
        font-size: 26px;
        font-weight: 600;
        text-align: center;
        color: var(--theme-color);
      }

      .year-date {
        display: block;
        width: 100%;
        height: 23px;
        line-height: 23px;
        color: #fff;
        text-align: center;
        background-color: var(--theme-color);
        font-size: 14px;
      }
    }

    .item-main {
      flex-grow: 1;
      max-width: 834px;
      height: 66px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      margin-right: auto;
      cursor: pointer;

      h3 {
        font-size: 16px;
        color: #333;
      }

      .item-main-info {
        font-size: 14px;
        color: #888888;
        line-height: 1;

        .info-time::after {
          content: '|';
          margin: 0 10px;
        }

        .info-time::before,
        .info-addr::before {
          margin-right: 4px;
        }
      }
    }

    .el-button {
      flex-basis: 90px;
      margin-left: 20px;
      border-color: var(--theme-color);
    }
  }
}

.pageDiv {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
